<template>
    <div>
        <v-app-bar app color="primary" flat fixed>
            <div class="container-fluid px-5">
                <div class="col-12 d-none d-md-block">
                    <div class="row">
                        <div class="col-auto align-self-center text-center white--text border-btn p-2">
                            <div class=" px-2">
                                <a href="tel:09126483554" class="white--text font-18">
                                    09126483554
                                </a>
                                <i class="fa-solid fa-phone px-2 font-18"></i>
                            </div>
                        </div>
                        <div class="col-auto align-self-center text-center white--text">
               <span
                       class="pointer"
                       @click.stop="drawerDesktop = !drawerDesktop">
             <i class="fa-solid fa-bars font-30"></i>
               </span>
                        </div>
                        <div class="col-auto align-self-center text-center white--text">
                            <!--               <span
                                               class="pointer"
                                               >
                                         <i class="fa-sharp fa-solid fa-sun-dust font-20"></i>
                                           </span>-->
                            <span class="round pointer" @click="dialog = true">
   <i class="fa-sharp fa-solid fa-sun-dust rounded-lg font-20 "></i>
 </span>


                        </div>
                        <!--            <div class="col-auto align-self-center">
                                      <img :alt="imageSeason.flagEnglish" src="../assets/img/Flag_of_the_United_States.png"
                                           class="p-0 english pointer" height="20"
                                           @click="setEnglishLanguage">
                                      <img :alt="imageSeason.flagIran" src="../assets/img/Flag_of_Iran.png" class="p-0 farsi pointer"
                                           height="20" @click="setFarsiLanguage">
                                    </div>-->
                        <div class="col align-self-center px-0 text-center ">

                            <router-link :to="item.path"
                                         v-for="item in navItems"
                                         :key="item.id"
                                         class="align-self-center navbar-items white--text nav-size ">
                                {{ item.text }}
                            </router-link>
                            <a href="https://sup.izisys.com/" target="_blank"
                               class="align-self-center navbar-items white--text nav-size ">
                                {{ $getText("MENU_ITEM_SUPPORT") }}
                            </a>
                        </div>
                        <div class="col-auto">
                            <img
                                    :alt="imageSeason.logo"
                                    src="../assets/img/izisys-logo-new.png"
                                    style="width:50px"/>
                        </div>
                    </div>
                </div>
                <div class="col-12 d-block d-md-none">
                    <div class="row">
                        <div class="col-4 align-self-center text-right pr-0">
            <span
                    class="pointer "
                    @click.stop="drawerPhone = !drawerPhone">
             <i class="fa-solid fa-bars font-32 white--text"></i></span>
                        </div>
                        <div class="col-4 align-self-center text-center">
              <span class="round pointer" @click="dialog = true">
           <i class="fa-sharp fa-solid fa-sun-dust rounded-lg font-28 white--text"></i>
         </span>

                        </div>
                        <!--            <div class="col-3 align-self-center text-center">
                                      <img :alt="imageSeason.flagEnglish" src="../assets/img/Flag_of_the_United_States.png"
                                           class="p-0 english pointer" height="20"
                                           @click="setEnglishLanguage">
                                      <img :alt="imageSeason.flagIran" src="../assets/img/Flag_of_Iran.png" class="p-0 farsi pointer"
                                           height="20" @click="setFarsiLanguage">
                                    </div>-->
                        <div class="col-4 align-self-center text-left pl-0">
                            <img
                                    :alt="imageSeason.logo"
                                    src="../assets/img/izisys-logo-new.png"
                                    style="width:30px"/>
                        </div>
                    </div>
                </div>
            </div>
        </v-app-bar>
        <div class="text-center">
            <v-dialog
                    v-model="dialog"
                    width="500"
            >

                <v-card>
                    <v-card-title class="justify-space-between secondary-bg "
                                  id="seasonDialogTitle">
                        <div class="white--text font-18">
                            {{ $getText("Select-Season") }}
                        </div>
                        <div class="d-flex align-self-end" id="seasonDialogClose">
                            <i class="fa-duotone fa-circle-xmark white--text pointer font-30"

                               @click="dialog = false"></i>
                        </div>
                    </v-card-title>

                    <v-card-text>
                        <p class="text-center font-18 pt-3">
                            {{ $getText("Select-Season-Title") }}
                        </p>
                        <div class="row ">
                            <div class="col-6 mx-auto">
                                <div class="row">
                                    <div class="col-6 bg-square pointer p-1" @click="setSpring">
                                        <v-img :src="getImgUrl('spring-select.jpg')" alt="spring"/>
                                    </div>
                                    <div class="col-6 bg-square1 pointer p-1" @click="setSummer">
                                        <v-img :src="getImgUrl('summer-select.jpg')" alt="summer"/>
                                    </div>
                                    <div class="col-6 bg-square2 pointer p-1" @click="setAutumn">
                                        <v-img :src="getImgUrl('autumn-select-1.jpg')" alt="autumn"/>
                                    </div>
                                    <div class="col-6 bg-square3 pointer p-1" @click="setWinter">
                                        <v-img :src="getImgUrl('winter-select.jpg')" alt="winter"/>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </v-card-text>

                </v-card>
            </v-dialog>
        </div>
        <v-navigation-drawer v-model="drawerDesktop" fixed right temporary color="">
            <v-list dense nav>
                <v-list-item-group
                        v-model="group"
                        active-class="deep-purple--text text--accent-4">
                    <div class="col-auto text-center py-10">
                        <img
                                :alt="imageSeason.logo"
                                src="../assets/img/izisys-logo-new.png"
                                style="width:90px"/>
                    </div>
                    <div class="col-auto text-center pt-3 font-20 white--text">
                        {{ $getText("CONTACT_INFORMATION") }}
                    </div>
                    <div class=" text-center">
                        <i class="col-4 bord white--text font-30 fa-duotone fa-phone"></i>
                    </div>
                    <div class=" text-center py-3">
                        <p>
                            <a href="tel:09126483554" class="white--text">
                                09126483554
                            </a>
                        </p>
                        <p>
                            <a href="tel:09126770412" class="white--text">
                                09126770412
                            </a>
                        </p>
                        <p>
                            <a href="tel:02122637630" class="white--text">
                                02122637630
                            </a>
                        </p>
                    </div>
                    <div class=" text-center">
                        <i class="col-4 bord white--text font-30 fa-solid fa-envelope"></i>
                        <p class="white--text">
                            {{ $getText("EMAIL-TEXT") }}
                        </p>
                    </div>

                </v-list-item-group>
            </v-list>
        </v-navigation-drawer>
        <v-navigation-drawer v-model="drawerPhone" fixed right temporary color="primary">
            <v-list dense nav>
                <v-list-item-group
                        v-model="group"
                        active-class="deep-purple--text text--accent-4">
                    <div class="col-auto text-center px-5" style="    border: 1px dashed white;">
                        <img
                                :alt="imageSeason.logo"
                                src="../assets/img/izisys-logo-new.png"
                                style="width:80px"/>
                        <p class="text-center white--text mt-3 mb-0">
                            <span class="d-block mt-3">IZISYS</span>
                            طراحی وب سایت اپلیکیشن موبایل و استارت اپ
                        </p>
                    </div>
                    <v-divider></v-divider>

                    <router-link :to="item.path"
                                 v-for="item in navItems"
                                 :key="item.id"
                                 class="align-self-center px-2 navbar-items">
                        <v-list-item>
                            <v-list-item-icon>
                                <span><i :class="item.icon" class="white--text text-align"></i></span>
                            </v-list-item-icon>
                            <v-list-item-title class="white--text text-align">{{ item.text }}</v-list-item-title>

                        </v-list-item>
                    </router-link>
                </v-list-item-group>
            </v-list>
            <div class="row pt-5 ">
                <div class="col-auto white--text border-btn p-2 mx-auto">
                    <div class=" px-2">
                        <a href="tel:09126483554" class="white--text font-18">
                            09126483554
                        </a>
                        <i class="fa-solid fa-phone px-2 font-18"></i>
                    </div>
                </div>
            </div>
        </v-navigation-drawer>
        <v-fab-transition>
            <v-btn
                    class="black--text secondary-bg"
                    elevation="0"
                    fab
                    fixed
                    bottom
                    left
                    @click="dialog = true"
            >

                <i class="fa-sharp fa-solid fa-sun-dust rounded-lg font-20 white--text"></i>
            </v-btn>
        </v-fab-transition>
    </div>
</template>

<script>

export default {
    name: "NavBar",
    components: {},
    data: () => ({
        required: [v => !!v || "پر کردن این فیلد الزامی است"],
        phone: null,
        code: null,
        searchKeyWord: null,
        showLoginModal: false,
        drawerPhone: false,
        drawerDesktop: false,
        group: null,
        absolute: false,
        opacity: 0.9,
        overlay: false,
        navItems: [],
        navItems1: [
            {
                id: 8,
                text: "021-22006388 ",
                icon: "fa-duotone fa-phone",
                path: "/"
            },
            {
                id: 1,
                text: "info@IZISYS.com ",
                icon: "fa-solid fa-envelope",
                path: "/"
            },
            {
                id: 2,
                text: "ظفر، بلوار آرش شرقی، خیابان فرید افشار، دولتشاد شرقی، نبش جام، پلاک 1، واحد 7",
                icon: "fa-solid fa-location-pin",
                path: "/AboutUs"
            },
        ],
        imageSeason: {},
        sup: [],
        dialog: false,
    }),
    mounted() {
        const d = new Date();
        let month = d.getMonth();
        this.imageSeason = this.$getimageSeason();
        if (this.$getUserSeason() === null) {
            this.$setUserSeason(this.$currentseasen(month))
            this.dialog = true

        }
        this.navItems = this.$getnavItems();
    },
    methods: {
        getImgUrl(pic) {
            return require("../assets/img/" + pic);
        },
        setAutumn() {
            this.$setUserSeason("Autumn")
            window.location.reload();
        },
        setWinter() {
            this.$setUserSeason("Winter")
            window.location.reload();
        },
        setSpring() {
            this.$setUserSeason("Spring")
            window.location.reload();
        },
        setSummer() {
            this.$setUserSeason("Summer")
            window.location.reload();
        },
        setEnglishLanguage() {
            this.$setLanguage("en")
            this.$changeRTL()
            this.refresh++;
            window.location.reload();
        },
        setFarsiLanguage() {
            this.$setLanguage("fa")
            this.$changeRTL()
            this.refresh++;
            window.location.reload();

        },
        search(e) {
            if (e.keyCode === 13) {
                this.searchBtn();
            }
        },
        searchBtn() {
            this.$router.replace({
                path: "Search",
                query: {KeyWord: this.searchKeyWord}
            });
            this.overlay = false;
        },
    }
};
</script>

<style scoped>
.font-32 {
    font-size: 32px;
}

@media (max-width: 768px) {
    #seasonDialogTitle {
      padding-top: 10px;
    }
    #seasonDialogClose{
        transform: translateY(-5px);
    }
}
</style>
